import React, { Component } from 'react';
import {
  Table,
  TableRow,
  TableHeader,
  TableHeaderColumn,
  TableBody,
  Checkbox,
  Popover,
  LinearProgress,
} from 'material-ui';
import ContractRow from './contract-row';
import LoadingOverlay from '../../../tc-ui/loading-overlay';
import ArrowDownIcon from 'material-ui/svg-icons/navigation/expand-more';
import ArrowUpIcon from 'material-ui/svg-icons/navigation/expand-less';
import UnfoldIcon from 'material-ui/svg-icons/navigation/unfold-more';
import R from 'ramda';
import RateConversionTableHeader from '../../dummy-account/rate-conversion-table-header';
import ListZeroState from '../../generic-components/zero-state';
import AssigneeFilter from '../../generic-components/assignee-filter';

const getSortIcon = (sort, rule) => {
  if (!sort) return <UnfoldIcon style={{ fill: 'rgba(0, 0, 0, 0.54)', width: '14px' }} />;
  if (rule === -1) return <ArrowDownIcon style={{ fill: 'rgba(0, 0, 0, 0.54)', width: '14px' }} />;
  return <ArrowUpIcon style={{ fill: 'rgba(0, 0, 0, 0.54)', width: '14px' }} />;
};

class ContractList extends Component {
  constructor() {
    super();
    this.state = {
      contactsOpen: null,
    };
  }

  openContacts = contract => e =>
    this.setState({
      contactsOpen: {
        from: contract.from || {},
        to: contract.to || {},
        toEmails: contract.toEmails || [],
        anchorEl: e.currentTarget,
      },
    });
  closeContacts = () => this.setState({ contactsOpen: null });

  render() {
    const { contactsOpen } = this.state;
    const {
      list,
      selectedContracts,
      actionsForContract,
      className,
      showFolder,
      hideStatusIcon,
      forLandingPage,
      hoveringOverContractId,
      selectCurrentAll,
      unselectAll,
      updateSearchParams,
      sortValue,
      sortRule,
      sentContractsCount,
      push,
      companyType,
      assignee,
      priority,
    } = this.props;
    const hasContent = Boolean(list.dataToShow && list.dataToShow.length);
    return (
      <div className={className} data-cy="list-content">
        {
          (list.loading && hasContent) && (
            <LinearProgress mode="indeterminate" />
          )
        }
        <Table bodyStyle={{ overflow: 'visible' }}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            {
              window.location.href.indexOf('/contract-list/rate-conversion') > -1
              ? (
                  <RateConversionTableHeader
                    sort={
                      value => updateSearchParams({
                        sortValue: value,
                        sortRule: sortValue === value && sortRule === -1 ? 1 : -1,
                      })
                    }
                    getSortIcon={getSortIcon}
                    sortRule={sortRule}
                    sortValue={sortValue}
                    filterByAssignee={
                      value => updateSearchParams({
                        assignee: value,
                      })
                    }
                    assigneeFilter={assignee}
                    priorityFilter={priority}
                    filterByPriority={
                      value => updateSearchParams({
                        priority: value,
                      })
                    }
                  />
                )
              : (
                    <TableRow>
                      <TableHeaderColumn colSpan="1">
                        <Checkbox
                          checked={Boolean(
                            selectedContracts.length >= list.dataToShow.length && list.dataToShow.length,
                          )}
                          onCheck={(_, inputChecked) => (inputChecked ? selectCurrentAll() : unselectAll())}
                        />
                      </TableHeaderColumn>
                      <TableHeaderColumn colSpan="1" />
                      <TableHeaderColumn colSpan="6" style={{ padding: 0 }}>
                        Contract
                      </TableHeaderColumn>
                      <TableHeaderColumn colSpan="1" style={{ padding: 0, textAlign: 'center' }} />
                      <TableHeaderColumn
                        data-walkthru="contractListStatus"
                        colSpan="1"
                        style={{ padding: 0, paddingLeft: '8px' }}
                      >
                        Status
                      </TableHeaderColumn>
                      {
                        companyType === 'Contractor' && (
                          <TableHeaderColumn colSpan="1" style={{ padding: 0, overflow: 'hidden' }}>
                            <AssigneeFilter
                              filter={assignee}
                              filterByAssignee={value => updateSearchParams({
                                assignee: value,
                              })}
                              isContainer
                            />
                          </TableHeaderColumn>
                        )
                      }
                      <TableHeaderColumn
                        colSpan="2"
                        style={{
                          padding: '0 0 0 2px',
                          textAlign: 'center',
                        }}
                      >
                        {
                          window.location.pathname.indexOf('contract-list') === -1 ? 'Contacts & Notes' : `Contacts Notes Activity`
                        }
                      </TableHeaderColumn>
                      <TableHeaderColumn colSpan="1" style={{ padding: 0, textAlign: 'center' }}>
                        <div
                          className="flex-tc-sb"
                          style={{ justifyContent: 'center', cursor: 'pointer' }}
                          onClick={() =>
                            updateSearchParams({
                              sortValue: 'endDate',
                              sortRule: sortValue === 'endDate' && sortRule === -1 ? 1 : -1,
                            })
                          }
                        >
                          Periods {getSortIcon(R.equals('endDate', sortValue), sortRule)}
                        </div>
                      </TableHeaderColumn>
                      <TableHeaderColumn colSpan="1" style={{ padding: 0, textAlign: 'center' }}>
                        <div
                          className="flex-tc-sb"
                          style={{ justifyContent: 'center', cursor: 'pointer' }}
                          onClick={() =>
                            updateSearchParams({
                              sortValue: 'updatedAt',
                              sortRule: sortValue === 'updatedAt' && sortRule === -1 ? 1 : -1,
                            })
                          }
                        >
                          Modified {getSortIcon(R.equals('updatedAt', sortValue), sortRule)}
                        </div>
                      </TableHeaderColumn>
                      <TableHeaderColumn colSpan="1" style={{ padding: 0, textAlign: 'center' }}>
                        Actions
                      </TableHeaderColumn>
                    </TableRow>
                )
            }
          </TableHeader>
          <TableBody style={{ overflow: 'visible' }}>
            {list.dataToShow.map((contract, i) => (
              <ContractRow
                key={i}
                showContractYear
                hideStatusIcon={hideStatusIcon}
                forLandingPage={forLandingPage}
                contract={contract}
                actions={actionsForContract}
                showFolder={showFolder}
                hoveringOverContractId={hoveringOverContractId}
                openContacts={this.openContacts(contract)}
              />
            ))}
          </TableBody>
        </Table>
        {
          !Boolean(sentContractsCount) && (
            <ListZeroState
              title="Welcome to the Contract List!"
              buttonTitle={companyType === 'Supplier'
                ? 'Start by creating a rate template'
                : 'Start by requesting rates'
              }
              videoLink="https://vimeo.com/432916768"
              buttonList={companyType === 'Supplier' ? [
                {
                  label: 'Create a Rate Template',
                  func: () => push(`/contracting/create-template-draft`),
                },
                {
                  label: 'Send a Contract',
                  func: () => {
                    window.location = `${process.env.NEW_SYSTEM_URL}/partner-management/send-assets?jwt=${
                      localStorage.getItem('jwt')
                    }&open_asset_type=rates`;
                  },
                },
              ] : [
                {
                  label: 'SEND A CONTRACT REQUEST',
                  func: () => {
                    window.location = `${process.env.NEW_SYSTEM_URL}/partner-management/send-assets?jwt=${
                      localStorage.getItem('jwt')
                    }&open_asset_type=requests`;
                  },
                },
              ]}
              enjoyBenefits={
                companyType === 'Supplier' ? [
                  'Track the status of each contract',
                  'View the rates & history for each partner',
                  'Send updates quickly',
                  'View real time statistics in your dashboard',
                ] : [
                  'Track the status of each contract',
                  'Manage the workflow for each contract',
                  'View the rates & history for each partner',
                  'Compare two versions of a contract',
                  'View real time statistics in your dashboard',
                ]
              }
            />
          )
        }
        <div
          style={{
            display: list.loading || hasContent || !sentContractsCount ? 'none' : 'block',
            minHeight: '400px',
            fontSize: '24px',
            textAlign: 'center',
            marginTop: '50px',
            marginBottom: '50px',
          }}
        >
          There are no files in this category.
        </div>
        <LoadingOverlay loading={list.loading && !hasContent} text={list.loadingText} />
        <Popover
          open={Boolean(contactsOpen)}
          onRequestClose={this.closeContacts}
          anchorEl={contactsOpen && contactsOpen.anchorEl}
          anchorOrigin={{ horizontal: 'middle', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'middle', vertical: 'top' }}
          style={{
            width: '350px',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            color: 'white',
            padding: '8px',
            fontSize: '12px',
          }}
        >
          {Boolean(contactsOpen) && (
            <div>
              This {contactsOpen.templateId ? 'contract' : 'contract request'} was prepared for{' '}
              <b>{contactsOpen.to.name}</b>
              <div style={{ marginTop: '12px' }}>
                From: {contactsOpen.from.name}
                <div style={{ marginLeft: '20px' }}>
                  ({contactsOpen.from.emailAlias || contactsOpen.from.email})
                </div>
              </div>
              <div style={{ marginTop: '12px' }}>
                To: {contactsOpen.to.name}
                <div style={{ marginLeft: '20px' }}>
                  {
                    contactsOpen.toEmails.map(str => (
                      <div key={str}>
                        {str}
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          )}
        </Popover>
      </div>
    );
  }
}

export default ContractList;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/list/list.jsx